// extracted by mini-css-extract-plugin
export default {"button":"gm-z","reviewSort":"hm-z"};